import { render, staticRenderFns } from "./qxDataBorad.vue?vue&type=template&id=2938ed6e&scoped=true"
import script from "./qxDataBorad.vue?vue&type=script&lang=js"
export * from "./qxDataBorad.vue?vue&type=script&lang=js"
import style0 from "./qxDataBorad.vue?vue&type=style&index=0&id=2938ed6e&prod&lang=scss&scoped=true"
import style1 from "./qxDataBorad.vue?vue&type=style&index=1&id=2938ed6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2938ed6e",
  null
  
)

export default component.exports